import React, { useState } from 'react';
import { Table, Dropdown, Menu, Button, Space, Typography } from 'antd';
import { EyeOutlined, FlagOutlined, CheckOutlined, DownOutlined } from '@ant-design/icons';
import './VerificationsProvider.css';

const { Title } = Typography;

const VerificationsProvider = () => {
  // Sample data for service providers KYC
  const dataSource = [
    { key: '1', name: 'Dave County services', date: '20/05/25', status: 'Verified', ip: '192.00.22' },
    { key: '2', name: 'Bush County services', date: '18/05/25', status: 'Pending Verification', ip: '192.00.22' },
    { key: '3', name: 'Bush County services', date: '18/04/25', status: 'Rejected', ip: '192.00.22' },
  ];

  // Define columns
  const columns = [
    { title: 'Name', dataIndex: 'name', key: 'name' },
    { title: 'Date', dataIndex: 'date', key: 'date' },
    { title: 'Status', dataIndex: 'status', key: 'status', render: (status) => (
      <span className={status === 'Verified' ? 'status-verified' : status === 'Rejected' ? 'status-rejected' : 'status-pending'}>{status}</span>
    )},
    { title: 'Last IP Address', dataIndex: 'ip', key: 'ip' },
    { 
      title: 'Action', 
      key: 'action', 
      render: (_, record) => (
        <Space size="middle">
          <Dropdown overlay={menu(record)} trigger={['click']}>
            <Button icon={<DownOutlined />} size="small">
              Actions
            </Button>
          </Dropdown>
        </Space>
      ),
    },
  ];

  // Menu for dropdown actions
  const menu = (record) => (
    <Menu>
      <Menu.Item key="1" icon={<EyeOutlined />} onClick={() => handleView(record)}>
        View
      </Menu.Item>
      <Menu.Item key="2" icon={<FlagOutlined />} onClick={() => handleFlag(record)}>
        Flag
      </Menu.Item>
      <Menu.Item key="3" icon={<CheckOutlined />} onClick={() => handleApprove(record)}>
        Approve
      </Menu.Item>
    </Menu>
  );

  // Placeholder functions for actions
  const handleView = (record) => {
    console.log('View:', record);
  };

  const handleFlag = (record) => {
    console.log('Flag:', record);
  };

  const handleApprove = (record) => {
    console.log('Approve:', record);
  };

  return (
    <div className="verifications-provider-container">
      <Title level={3} className="verifications-provider-title">Service Providers KYC</Title>
      <Table
        dataSource={dataSource}
        columns={columns}
        pagination={{ pageSize: 5 }}
        className="verifications-provider-table"
      />
    </div>
  );
};

export default VerificationsProvider;